import { h } from 'preact';
import Media from 'utils/media';
import { generateUrl } from 'utils/helpers';

const ProductGalleryLookOverlay = ({ currentProduct: { media, handle } }) => {
  const firstMedia = media[0];

  const handleMediaClick = () => {
    window.location.href = generateUrl(handle, 'products');
  };

  return (
    <div className="ml:w-[6.9375rem] lc:w-[7.375rem] lc:md:w-[10.5rem] absolute">
      {firstMedia && (
        <div
          key={firstMedia.previewImage.id}
          className={`relative lc:h-[158px] lc:md:h-[224px] ml:h-[148px]`}
        >
          <Media
            {...firstMedia}
            className="absolute inset-0 object-cover h-full w-full"
            srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
            onClick={handleMediaClick}
            parentClass="cursor-pointer"
            // eslint-disable-next-line no-unneeded-ternary
            lazyLoad={false}
          />
        </div>
      )}
    </div>
  );
};
export default ProductGalleryLookOverlay;
